module.exports = __webpack_public_path__ + "static/img/医生文章@3x.f240569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medical/index/医生文章@3x.png
// module id = 789
// module chunks = 382